import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Meta from '../../../../model/Meta';

/* Steps */
import DefaultView from './DefaultView';
import SpecialPowerOfAttorneyToSellStep1 from './SpecialPowerOfAttorneyToSellStep1';
import SpecialPowerOfAttorneyToSellStep2 from './SpecialPowerOfAttorneyToSellStep2';
import SpecialPowerOfAttorneyToSellStep3 from './SpecialPowerOfAttorneyToSellStep3';
import SpecialPowerOfAttorneyToSellStep4 from './SpecialPowerOfAttorneyToSellStep4';
import SpecialPowerOfAttorneyToSellStep5 from './SpecialPowerOfAttorneyToSellStep5';
import Ty from './Ty';

const SpecialPowerOfAttorneyToSell = (props)=>{
	let basePath = "/contracts/free-contracts/special-power-of-attorney-to-sell";

	const meta = {
		title: "Special Power of Attorney to Sell Contract",
		description: "A Special Power of Attorney (to Sell) is a legal document that results in the grant of authorization to sell a real property from one person called the principal to another called the attorney-in-fact. This document is the popular choice for sellers who are certain to have difficulties in attending to the execution of the sale documents such as when they are abroad, in another town, or it may also be due to physical infirmity or old age."
	}

	return (
		<div className="page page-inner page-contract">
			<Meta {...meta}/>
			<div className="container-fluid">
				<div className="p-0">
					<div className="page-content py-3">

						<Switch>
							<Route path={basePath+"/1"} component={SpecialPowerOfAttorneyToSellStep1} />
							<Route path={basePath+"/2"} component={SpecialPowerOfAttorneyToSellStep2} />
							<Route path={basePath+"/3"} component={SpecialPowerOfAttorneyToSellStep3} />
							<Route path={basePath+"/4"} component={SpecialPowerOfAttorneyToSellStep4} />
							<Route path={basePath+"/5"} component={SpecialPowerOfAttorneyToSellStep5} />
							<Route path={basePath+"/ty"} component={Ty} />
							<Route component={DefaultView} />
						</Switch>

					</div>
				</div>
			</div>
		</div>
	);
}

export default SpecialPowerOfAttorneyToSell;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/special-power-of-attorney-to-sell/SpecialPowerOfAttorneyToSell.js